import { Route as ngRoute, Routes } from '@angular/router';
import { AuthenticationGuard } from './authentication/authentication.guard';

export class Route {

  static withShell(routes: Routes): Routes {
    return [{
      path: '',
      children: routes,
      canActivate: [AuthenticationGuard]
    }];
  }

}
